module.exports = __webpack_public_path__ + "img/Lol_06.e534027f.png";